/*
 * File: CommentCreator.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 2, 2025 at 11:46 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.div`
	input {
		border-radius: 10px;
		padding: 14px 16px !important;
		font-size: 0.975rem !important;
	}
`;

export const CreatorContainer = styled.div`
	border: 1px solid ${({ theme }) => theme.inputBorder};
	border-radius: 10px;

	&:focus {
		border-color: ${({ theme }) => theme.inputFocusBorder};
	}
	textarea {
		background-color: transparent !important;
		font-weight: 400;
		padding: 14px 16px !important;
		font-size: 0.975rem !important;
	}
`;

export const AlertContainer = styled.div`
	display: flex;
	gap: 10px;
	margin-top: ${({ $height }) => `-${$height}px`};
	opacity: 0;
	pointer-events: none;
	max-width: 500px;
	width: 100%;

	&.show {
		margin-top: 10px;
		opacity: 1;
		pointer-events: all;
	}
	p {
		margin: 0px;
	}
`;

export const Spacer = styled.div`
	flex-grow: 1;
`;

export const Actions = styled.div`
	display: flex;
	gap: 8px;
	margin: 4px 0px 0px;
	width: 100%;
	padding: 6px 8px;

	button {
		span {
			font-size: 14px !important;
		}
	}
`;
